var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalizado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_545",
    "data-name": "Grupo 545",
    transform: "translate(-436 -822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_541",
    "data-name": "Grupo 541",
    transform: "translate(395.297 822.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_966",
    "data-name": "Trazado 966",
    d: "M51.605,19.777a5.882,5.882,0,0,1,2.842-2.8,7.926,7.926,0,0,1,2.993-.732,6.927,6.927,0,0,1,1.028.076,7.215,7.215,0,0,1,.978.216,8.207,8.207,0,0,0,1.041-2.054A7.438,7.438,0,0,0,60.9,12a7.62,7.62,0,0,0-2.3-5.6,7.961,7.961,0,0,0-11.2,0A7.619,7.619,0,0,0,45.1,12a7.577,7.577,0,0,0,1.285,4.28,8.3,8.3,0,0,1,4.048-1.03,7.329,7.329,0,0,1,1.3.115,11.147,11.147,0,0,1,1.128.257,5.836,5.836,0,0,0-.746.505,7.72,7.72,0,0,0-.666.6,2.785,2.785,0,0,0-.483-.064q-.268-.014-.53-.015a6.938,6.938,0,0,0-1.64.2,6.292,6.292,0,0,0-1.528.587,7.523,7.523,0,0,0,1.985,1.525A8.045,8.045,0,0,0,51.605,19.777ZM53,21.3a9.049,9.049,0,0,1-3.626-.733,9.3,9.3,0,0,1-4.942-4.941,9.331,9.331,0,0,1,0-7.248,9.3,9.3,0,0,1,4.941-4.942,9.331,9.331,0,0,1,7.248,0,9.3,9.3,0,0,1,4.942,4.941,9.331,9.331,0,0,1,0,7.248,9.3,9.3,0,0,1-4.941,4.942A9.035,9.035,0,0,1,53,21.3ZM50.54,13.19a3.17,3.17,0,0,1-3.168-3.17,3.169,3.169,0,1,1,5.409,2.242A3.056,3.056,0,0,1,50.54,13.19Zm0-1.4a1.768,1.768,0,0,0,1.248-3.021,1.768,1.768,0,1,0-2.5,2.5A1.708,1.708,0,0,0,50.543,11.791Zm6.9,2.611a2.381,2.381,0,0,1-2.4-2.4,2.4,2.4,0,1,1,4.108,1.7A2.313,2.313,0,0,1,57.443,14.4Z",
    fill: "#e7e7e7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_348",
    "data-name": "Rect\\xE1ngulo 348",
    width: 24,
    height: 24,
    transform: "translate(436 822)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizado);
export default __webpack_public_path__ + "static/media/personalizado.95acd598bde56d2022665da700aea5af.svg";
export { ForwardRef as ReactComponent };